var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14.9667 29.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 29.08,
    opacity: 0,
    width: 14.9667,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48248 0.174364C3.32142 0.174364-4.44089e-16 3.49576-4.44089e-16 7.62947C-4.44089e-16 10.7691 1.87397 13.5251 4.79947 14.6362L4.79947 26.2019C4.79947 26.4931 4.89655 26.7148 5.11324 26.944L7.06173 28.9198C7.25359 29.0993 7.66166 29.1639 7.90321 28.9224L11.6235 25.202C11.8674 24.9531 11.855 24.5998 11.6235 24.3659L9.31545 22.0852L12.4733 18.9323C12.7022 18.7108 12.7022 18.3575 12.4434 18.1086L9.32509 14.953C12.9463 13.5228 14.9649 10.8391 14.9649 7.62947C14.9649 3.51071 11.6311 0.174364 7.48248 0.174364ZM7.48248 7.04327C6.38885 7.04327 5.5294 6.15646 5.5294 5.07524C5.5294 3.98415 6.38885 3.12218 7.48248 3.12218C8.5637 3.12218 9.45051 3.98415 9.45051 5.07524C9.45051 6.15646 8.5637 7.04327 7.48248 7.04327Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ef4f00c188e543d5552e147f2ba3aa23.svg";
export { ForwardRef as ReactComponent };